import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../lib/api";
import { errMsg } from "../lib/errors";
import { useAuth } from "../context/AuthContext";

const AuthCallback = () => {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash;
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate("/");
      return;
    }
    const sessionId = match[1];

    (async () => {
      try {
        const res = await api.post("/auth/session", { session_id: sessionId });
        setUser(res.data);
        window.history.replaceState(null, "", "/dashboard");
        navigate("/dashboard", { replace: true });
      } catch (e) {
        setError(errMsg(e, "Sign in failed"));
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F9F9F8] px-6">
      {error ? (
        <div className="text-center max-w-sm">
          <div className="font-display text-2xl font-medium text-[#1A1A1A]">Access denied</div>
          <p className="text-[#4A4A4A] mt-3">{error}</p>
          <button onClick={() => (window.location.href = "/")} className="mt-6 bg-[#2C2C2C] text-white rounded-md px-6 py-3 text-sm font-semibold">Back to login</button>
        </div>
      ) : (
        <div className="text-[#737373] text-sm">Signing you in…</div>
      )}
    </div>
  );
};

export default AuthCallback;
